import React, { useState } from 'react';
import { Paper, Popover, ClickAwayListener } from '@material-ui/core';
import DateInput from './components/DateInput';
import Calendar from './components/Calendar';
import { useDatePicker } from './hooks/useDatePicker';
import { useStyles } from './styles';

const DatePicker = ({
    value = null,
    onChange,
    disablePast = false,
    disableFuture = false,
    minDate = null,
    maxDate = null,
    placeholder = "Оберіть дату"
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const {
        selectedDate,
        currentMonth,
        handleDateClick,
        goToNextMonth,
        goToPreviousMonth
    } = useDatePicker(value);

    const handleInputClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDateClickInternal = (date) => {
        handleDateClick(date);
        if (onChange) {
            onChange(date);
        }
        setTimeout(() => {
            handleClose();
        }, 200);
    };

    const open = Boolean(anchorEl);

    return (
        <div>
            <DateInput
                value={selectedDate}
                onClick={handleInputClick}
                placeholder={placeholder}
            />

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    className: classes.paper
                }}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper className={classes.paper} elevation={0}>
                        <Calendar
                            currentMonth={currentMonth}
                            selectedDate={selectedDate}
                            onPreviousMonth={goToPreviousMonth}
                            onNextMonth={goToNextMonth}
                            onDateClick={handleDateClickInternal}
                            disablePast={disablePast}
                            disableFuture={disableFuture}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </Paper>
                </ClickAwayListener>
            </Popover>
        </div>
    );
};

export default DatePicker;
